export default () => {

  const bg = document.querySelector('.js-blue-block');

  window.onload = function() {
    const ua = navigator.userAgent;
    if (ua.match(/(iPod|iPhone|iPad)/) !== null && ua.match(/AppleWebKit/) !== null && ua.search('CriOS') < 0) {
      bg.classList.add('-mobile-safari');
    }
  };
};